import React, { useEffect, useState } from 'react';
import styles from './LoadingSpinner.module.css';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'small' | 'medium' | 'large';
  fullscreen?: boolean;
  show?: boolean;
  onClose?: () => void;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = '잠시만 기다려주세요...',
  size = 'medium',
  fullscreen = true,
  show = true,
  onClose
}) => {
  const [isVisible, setIsVisible] = useState(show);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (show && !isVisible) {
      // 100ms 지연 후에 컴포넌트가 나타나도록 설정
      const showTimer = setTimeout(() => {
        setIsVisible(true);
        setIsAnimating(false);
        if (fullscreen) {
          document.body.style.overflow = 'hidden';
        }
      }, 100);

      return () => clearTimeout(showTimer);
    } else if (!show && isVisible) {
      setIsAnimating(true);
      setTimeout(() => {
        setIsVisible(false);
        setIsAnimating(false);
        if (fullscreen) {
          document.body.style.overflow = '';
        }
        onClose?.();
      }, 300);
    }
  }, [show, isVisible, onClose, fullscreen]);

  useEffect(() => {
    return () => {
      if (fullscreen) {
        document.body.style.overflow = '';
      }
    };
  }, [fullscreen]);

  if (!isVisible) return null;

  const overlayClass = isAnimating
    ? `${styles.overlay} ${styles.fadeOut}`
    : styles.overlay;

  return (
    <div className={fullscreen ? overlayClass : styles.container}>
      <div className={styles.content}>
        <div className={`${styles.spinner} ${styles[size]}`} />
        <p className={styles.message}>{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner; 